import { Link, useLocation } from "react-router-dom";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Image from "react-bootstrap/Image";
import Button from "@material-ui/core/Button";
import { isLoggedIn } from "axios-jwt";
import { useTranslation } from "react-i18next";
import FuzzySet from "fuzzyset";
import { useEffect } from "react";
import { JOBS_RESULTS, HOME, LOGIN } from "src/router/routes";
import { CUSTOMER_SERVICE_EMAIL, CUSTOMER_SERVICE_PHONE } from "src/constants/contact_info";
import errorImg from "src/images/404-Graphic.svg";

function PageNotFound() {
  const { t } = useTranslation();
  const { search } = useLocation();


  useEffect(() => {
    const fuzzySet = FuzzySet();
    fuzzySet.add(JOBS_RESULTS);
  }, [search]);

  return (
    <div
      className={
        isLoggedIn() ? "container-fluid errorPageBanner" : "container-fluid notLogPageBanner"
      }
    >
      {isLoggedIn() ? null : <div className="errPageLogo" />}
      <div className={isLoggedIn() ? "errorImgDiv" : "notLogErrImg"}>
        <Image src={errorImg} />
      </div>
      <div className="erroPageMainTxt">
        {t("pageNotFound.errorHeading1")}{" "}
        <span className="errPagetxtmob">{t("pageNotFound.errorHeading2")}</span>
      </div>
      <div className="errorPageBackbtn">
        <Button className="errPageBtn">
          <Link to={isLoggedIn() ? HOME : LOGIN}>
            <ArrowBackIcon fontSize="small" />{" "}
            {isLoggedIn() ? t("pageNotFound.dashboardLabel") : t("pageNotFound.loginLabel")}
          </Link>
        </Button>
      </div>
      <div className="errorPageSubTxt">
        {t("pageNotFound.errHelpMsg")}
        <span className="mt-3 errPhnPadding">
          &nbsp;
          <a className="custServiceNo" href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>
            {CUSTOMER_SERVICE_EMAIL}{" "}
          </a>
        </span>
        <br />
        {t("pageNotFound.errHelpPhone")}
        <span className="mt-3 errPhnPadding">
          &nbsp;
          <a href={`tel:${CUSTOMER_SERVICE_PHONE}`} className="custServiceNo">
            {CUSTOMER_SERVICE_PHONE}
          </a>
        </span>
      </div>
    </div>
  );
}
export default PageNotFound;
